import type { FaireProductEntity } from "../../entity_types/product";

export const p_t2rvm3gjh2: FaireProductEntity = {
  token: "p_t2rvm3gjh2",
  type: "product",
  name: "GANESHA SILVER COIN 100 GMS",
  brandToken: "b_ftaz83cznh",
  brandName: "Ancientveda",
  imageUrl:
    "https://cdn.faire.com/fastly/a2cd33144698213fe2ec09410ef6c66df547c4e6e04efaedfd8b7d6ef4063b85.jpeg",
  galleryImageUrls: [],
  priceDollars: 349.19,
  description:
    "Celebrate Diwali, the Festival of Lights, with our exquisite range of Indian Diwali goods. Immerse yourself in the festivity with our hand-picked selection – ornate diyas to cast a warm, welcoming glow, vibrant rangolis for a touch of auspicious art, and eco-friendly decorations to beautify your space sustainably. Savor the season with traditional sweets crafted from time-honored recipes. Whether gifting loved ones or adorning your home, our products promise to enhance the joy and spirit of Diwali.",
  tags: [],
  msrpDollars: 872.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:58.998Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
